import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const TYPEFORM_URL = 'https://71qjlbfvzsh.typeform.com/to/eaDwqsLQ';

export const openTypeform = (source = 'website') => {
    try {
        window.location.href = `${TYPEFORM_URL}?utm_source=website-${source}`;
    } catch (error) {
        // Ignore the "Receiving end does not exist" error as it's harmless
        if (!error.message.includes('Receiving end does not exist')) {
            console.error('Error opening Typeform:', error);
        }
    }
};

// Questionnaire component for direct redirects
export const Questionnaire = () => {
    const [searchParams] = useSearchParams();
    const source = searchParams.get('source') || 'general';

    useEffect(() => {
        window.location.href = `${TYPEFORM_URL}?utm_source=${source}`;
    }, [source]);
    return null;
}; 
